/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

const template = [
  {
    id: uuidV4(),
    index: "1",
    title: "Tổng số người lao động",
    bg: false,
    spendId: 16,
    value: 0,
  },
  {
    id: uuidV4(),
    isTitle: false,
    spendId: 17,
    value: 0,
    title: "Trong đó: Cá nhân cư trú có hợp đồng lao động",
  },
  {
    id: uuidV4(),
    index: "2",
    spendId: 18,
    value: 0,
    title: "Trong đó: Cá nhân cư trú có hợp đồng lao động",
  },
  {
    id: uuidV4(),
    index: "2.1",
    spendId: 19,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "2.2",
    spendId: 20,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "3",
    spendId: 21,
    value: 0,
    title: "Tổng thu nhập chịu thuế trả cho cá nhân [21]=[22]+[23]",
  },
  {
    id: uuidV4(),
    index: "3.1",
    spendId: 22,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "3.2",
    spendId: 23,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "3.3",
    spendId: 24,
    value: 0,
    title:
      "Trong đó: Tổng thu nhập chịu thuế từ tiền phí mua bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác của doanh nghiệp bảo hiểm không thành lập tại Việt Nam cho người lao động",
  },
  {
    id: uuidV4(),
    index: "4",
    spendId: 25,
    value: 0,
    title: "Trong đó tổng thu nhập chịu thuế được miễn theo quy định của Hợp đồng dầu khí",
  },
  {
    id: uuidV4(),
    index: "5",
    spendId: 26,
    value: 0,
    title: "Tổng thu nhập chịu thuế trả cho cá nhân thuộc diện phải khấu trừ thuế [26]=[27]+[28]",
  },
  {
    id: uuidV4(),
    index: "5.1",
    spendId: 27,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "5.2",
    spendId: 28,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "6",
    spendId: 29,
    value: 0,
    title: "Tổng số thuế thu nhập cá nhân đã khấu trừ [29]=[30]+[31]",
  },
  {
    id: uuidV4(),
    index: "6.1",
    spendId: 30,
    value: 0,
    title: "Cá nhân cư trú",
  },
  {
    id: uuidV4(),
    index: "6.2",
    spendId: 31,
    value: 0,
    title: "Cá nhân không cư trú",
  },
  {
    id: uuidV4(),
    index: "6.3",
    spendId: 32,
    value: 0,
    title:
      "Trong đó: Tổng số thuế thu nhập cá nhân đã khấu trừ trên tiền phí mua bảo hiểm nhân thọ, bảo hiểm không bắt buộc khác của doanh nghiệp bảo hiểm không thành lập tại Việt Nam cho người lao động",
  },
];

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState(template);

  useEffect(() => {
    setFieldValue("valuesTableII", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type } = values;
    console.log({ id, name, value, type });
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value };
        }
        return item;
      })
    );
  };

  const isBg = (index) => {
    return ["2", "3", "4", "5", "6"].includes(index);
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Đơn vị tính
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#f4f4f4" }}>
                Số người/Số tiền
              </Td>
            </tr>
            {data.map((item) => {
              return (
                <tr key={item.id}>
                  {item.spendId !== 17 && (
                    <Td
                      rowSpan={item.spendId === 16 ? 2 : 1}
                      style={{
                        textAlign: "center",
                        background:
                          isBg(item.index) || item.index === "6.3" ? "#ddeff3" : "transparent",
                        fontWeight: isBg(item.index) || item.index === "6.3" ? "bold" : "400",
                      }}
                    >
                      {item.index}
                    </Td>
                  )}
                  <Td
                    style={{
                      textAlign: "left",
                      maxWidth: 400,
                      background:
                        isBg(item.index) || item.index === "6.3" ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.index) || item.index === "1" ? "bold" : "400",
                    }}
                  >
                    {item.title}
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background:
                        isBg(item.index) || item.index === "6.3" ? "#ddeff3" : "transparent",
                      fontWeight: "bold",
                    }}
                  >
                    [{item.spendId}]
                  </Td>
                  <Td
                    style={{
                      textAlign: "center",
                      background:
                        isBg(item.index) || item.index === "6.3" ? "#ddeff3" : "transparent",
                    }}
                  >
                    {item.spendId > 20 ? "VNĐ" : "Người"}
                  </Td>
                  <Td
                    style={{
                      textAlign: "right",
                      paddingRight: isBg(item.index) || item.index === "6.3" ? 20 : 8,
                      background:
                        isBg(item.index) || item.index === "6.3" ? "#ddeff3" : "transparent",
                      fontWeight: isBg(item.index) ? "bold" : "400",
                    }}
                  >
                    {isBg(item.index) || item.index === "6.3" ? (
                      0
                    ) : (
                      <InputTable
                        id={item.id}
                        name="value"
                        value={item.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { id, onChange, type = "text", name, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
